export default __webpack_public_path__ + "static/media/countries.e6c88632.jpg";